import {ConversationUserEntity} from './ConversationUserEntity.js'
import UserEntity from './UserEntity.js'

export default class UserEntityFactory {
  /**
   * @method
   * @param {Object} user
   * @param {String} user.lastName
   * @param {String} user.name
   * @param {String} user.email
   * @param {String} user.phone
   * @param {Number} user.userId
   * @param {String} user.avatar
   * @param {String} user.token
   * @param {String} user.isEmailConfirmed
   * @param {String|Number} contractId,
   * @param {String} user.province
   */
  static userEntity = ({
    active,
    avatar,
    avatarUrl,
    contractId,
    creationDate,
    email,
    hidePhone,
    id,
    isEmailConfirmed,
    lastName,
    name,
    origin,
    phone,
    province,
    provinceId,
    token,
    userId,
    verified,
    zipCode
  }) =>
    new UserEntity({
      active,
      avatar: avatar || avatarUrl,
      contractId,
      creationDate,
      email,
      hidePhone,
      isEmailConfirmed,
      lastName,
      name,
      origin,
      phone,
      province,
      provinceId,
      token,
      userId: userId || id,
      verified,
      zipCode
    })

  static conversationUserEntity = ({conversationId}) =>
    new ConversationUserEntity({
      conversationId
    })
}
